/**
 * Toggles html.is-scrolled, which collapses the header wordmark to the
 * "odontia-o" mark (components/logo.css). Two thresholds (hysteresis) so
 * the logo doesn't flicker when the page rests right at the boundary or
 * iOS rubber-bands at the top.
 */

const ENTER = 40; // px scrolled before collapsing
const LEAVE = 10; // px from the top before expanding again

function initHeaderLogo() {
	const root = document.documentElement;
	let scrolled = null;
	let ticking = false;

	const update = () => {
		ticking = false;
		const y = window.scrollY;
		const next = scrolled ? y > LEAVE : y > ENTER;
		if ( next !== scrolled ) {
			scrolled = next;
			root.classList.toggle( 'is-scrolled', next );
		}
	};

	window.addEventListener( 'scroll', () => {
		if ( ! ticking ) {
			ticking = true;
			requestAnimationFrame( update );
		}
	}, { passive: true } );

	update();
}

initHeaderLogo();
